import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import Navbar from "../components/Navbar";
import InfoCardLightening from "../components/tour/InfoCardLightening";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";
import TourManagementWelcomeModal from "../components/Modal/TourManagementWelcomeModal";
import { resetTourEdit } from "../reducer/tourEditReducer";

function TourManagementPackageNamePage() {
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const { packageData } = useSelector((state: RootState) => state.tour);
  const { tourEdit, id } = useSelector((state: RootState) => state.edit);
  const { createPrePackage } = usePackage();
  const progressref = useRef(1);
  useOnLoadPage({ tabActive: "create" });
  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);

  useEffect(() => {
    if (location.state && location.state.packageData) {
      dispatch(setPackageData(location.state.packageData));
    }
  }, [location.state, dispatch]);

  const onContinue = () => {
    if (!packageData.title) {
      setError("Please complete this field.");
      return;
    }
    setError("");

    dispatch(addActiveTab(Paths.tourManagementPackageDescription));
    navigate(Paths.tourManagementPackageDescription);
  };

  const onSave = async () => {
    if (!packageData.title) {
      setError("Please complete this field.");
      return;
    }
    setError("");

    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    const updatedPackageData2 = {
      ...packageData,
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetTourEdit());
        dispatch(setPackageData(updatedPackageData2));
        navigate(Paths.manageProductDetails.replace(":id", id), {
          state: { fromEdit: true },
        });
        return;
      } else {
        await createPrePackage(updatedPackageData);
        navigate(Paths.welcome);
      }
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <TourManagementWelcomeModal />
      <div className={Classname.content}>
        {/* Sidebar */}

        <TourManagementSidebar selected={1} />

        {/* Main Content */}
        <div className={Classname.detail}>
          <span className={Classname.title}>
            What is the customer-facing title of your package?
          </span>
          <input
            type="text"
            placeholder="Enter your details"
            value={packageData.title || ""}
            onChange={(e) => {
              dispatch(
                setPackageData({
                  title: e.target.value,
                })
              );
              if (error) setError("");
            }}
            className={`${Classname.input} ${
              error ? "border-red-500" : "border-gray-400"
            }`}
          />
          <span className="mt-4 text-red-600">{error}</span>
          <InfoCardLightening
            className="mt-10 mb-10"
            description="Start with the main location followed by a colon (:), and include the activity type (e.g. tour), and the important inclusions or unique selling points."
          />
          <span className={Classname.title}>
            Create a package reference code 
          </span>
          <p className={Classname.description}>
            To help you keep track of your packages on Intraverse, you can add
            your internal code. If you do not add one, we will assign one
            automatically.
          </p>
          <input
            type="text"
            placeholder="Enter your details"
            value={packageData.referenceCode || ""}
            onChange={(e) => {
              dispatch(
                setPackageData({
                  ...packageData,
                  referenceCode: e.target.value,
                })
              );
            }}
            className={Classname.input}
          />
          <div className={Classname.buttonsContainer}>
            <button
              className={Classname.saveButton}
              onClick={onSave}
              disabled={loading}
            >
              {loading ? "Please wait..." : "Save and exit"}
            </button>
            {!tourEdit && (
              <button className={Classname.continueButton} onClick={onContinue}>
                Continue
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageNamePage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  description: "flex text-base mb-4",
  buttonsContainer: "flex flex-1 justify-between lg:justify-end gap-3 mt-10",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
